"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrgSearchPage = exports.OrgSearchConfig = void 0;
const tslib_1 = require("tslib");
const core_api_1 = require("@ikegps/core-api");
const mobx_1 = require("mobx");
const icon_1 = require("../components/icon");
const icons_1 = require("../components/icon/icons");
const table_1 = require("../components/table/table");
const theme_1 = require("../components/theme");
const i18n_1 = require("../i18n");
const mithril_1 = require("../mithril");
const services_1 = require("../services");
const org_search_style_1 = require("./org.search.style");
const page_1 = require("./page");
(0, theme_1.addStyles)(org_search_style_1.Style);
exports.OrgSearchConfig = {
    type: 'internal',
    name: page_1.IkePageName.orgSearch,
    path: '/org/search',
    auth: {
        required: true,
        tokens: [core_api_1.IkeToken.ORG_SEARCH_PAGE],
    },
    nav: {
        name: i18n_1.T.ORG_SEARCH,
        icon: icons_1.MaterialIcon.ORG_SEARCH,
    },
};
class OrgSearchPage extends page_1.IkePage {
    constructor() {
        super(exports.OrgSearchConfig);
        this.rows = [];
        this.timer = null;
        this.searchResponse = null;
        this.searchQuery = null;
    }
    viewPole(primary, secondary, department, index) {
        return [
            (0, mithril_1.m)('span', { className: org_search_style_1.CSS.tableCell }, String(index)),
            (0, mithril_1.m)('span', { className: org_search_style_1.CSS.tableCell }, `${primary == null ? (0, i18n_1.Translate)(i18n_1.T.EMPTY) : primary}`),
            (0, mithril_1.m)('span', { className: org_search_style_1.CSS.tableCell }, `${secondary == null ? (0, i18n_1.Translate)(i18n_1.T.EMPTY) : secondary}`),
            (0, mithril_1.m)('span', { className: org_search_style_1.CSS.tableCell }, `${department == null ? (0, i18n_1.Translate)(i18n_1.T.EMPTY) : department}`),
        ];
    }
    viewPoles() {
        const headers = ['#', 'Primary', 'Secondary', 'Department'];
        while (this.rows.length > 0) {
            this.rows.pop();
        }
        const results = this.searchResponse;
        if (results != null && this.searchQuery != null) {
            let count = 0;
            results.forEach((el) => {
                count++;
                this.rows.push(this.viewPole(el.primary, el.secondary, el.departmentName, count));
            });
        }
        if (this.rows.length > 0) {
            //results
            return table_1.Table.view((0, i18n_1.Translate)(i18n_1.T.SEARCH_RES), headers, this.rows);
        }
        else if (this.searchQuery != null) {
            //query but no results
            return table_1.Table.view((0, i18n_1.Translate)(i18n_1.T.TAG_FILTER__SEARCH_EMPTY), [], this.rows);
        }
        else {
            return table_1.Table.view((0, i18n_1.Translate)(i18n_1.T.INPUT_REQUIRED), [], this.rows);
        }
    }
    sendQ(str) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            if (str === '' || str == null) {
                this.searchResponse = null;
                this.searchQuery = null;
            }
            else {
                this.searchQuery = str;
                this.searchResponse = yield services_1.Services.SearchOrg.sendQuery(this.searchQuery);
            }
            return true;
        });
    }
    onChange(e) {
        clearTimeout(this.timer);
        this.timer = setTimeout((val) => {
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            this.sendQ(val);
        }, 300, e.target.value);
    }
    get nodes() {
        if (!services_1.Services.User.hasUser) {
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            services_1.Services.User.logout();
            return null;
        }
        if (!services_1.Services.Token.has(core_api_1.IkeToken.ORG_SEARCH_PAGE) && !services_1.Services.Token.has(core_api_1.IkeToken.FEATURE_GROUP_IKE_ANALYZE)) {
            const lockedOut = (0, mithril_1.m)('div', { className: 'container' }, [
                (0, mithril_1.m)('span', { className: 'title' }, 'No Organization Search Feature Token'),
            ]);
            return lockedOut;
        }
        const icon = icon_1.Icon.view(icons_1.MaterialIcon.ORG_SEARCH, { className: org_search_style_1.CSS.box.icon });
        let children = [
            (0, mithril_1.m)('header', { className: org_search_style_1.CSS.search.container }, [
                (0, mithril_1.m)('div', { className: org_search_style_1.CSS.search.row }, [
                    (0, mithril_1.m)('div', { className: org_search_style_1.CSS.search.section }, [(0, mithril_1.m)('span', { className: 'title' }, (0, i18n_1.Translate)(i18n_1.T.ORG_SEARCH))]),
                    (0, mithril_1.m)('div', { className: org_search_style_1.CSS.box.container }, [
                        icon,
                        (0, mithril_1.m)('input', {
                            className: org_search_style_1.CSS.box.input,
                            type: 'text',
                            placeholder: 'search by secondary or primary field',
                            oninput: (e) => this.onChange(e),
                        }),
                    ]),
                    (0, mithril_1.m)('div', { className: `${org_search_style_1.CSS.search.section} ${org_search_style_1.CSS.search.sectionRight}` }),
                ]),
            ]),
            (0, mithril_1.m)('div', { className: 'results' }, [this.viewPoles()]),
        ];
        const nodes = (0, mithril_1.m)('div', { className: 'container' }, children);
        return nodes;
    }
}
exports.OrgSearchPage = OrgSearchPage;
tslib_1.__decorate([
    mobx_1.observable
], OrgSearchPage.prototype, "searchResponse", void 0);
tslib_1.__decorate([
    mobx_1.observable
], OrgSearchPage.prototype, "searchQuery", void 0);
//# sourceMappingURL=org.search.page.js.map